import { useMemo } from "react";
import type { Moment } from "moment";
import { object, string, mixed, array } from "yup";
import { FormField } from "./types";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            [FormField.CompanyName]: string()
                .required()
                .trim()
                .min(1)
                .label('Business Activity'),
            [FormField.RegistrationNumber]: string()
                .required()
                .trim()
                .min(1)
                .label('Registration Number'),
            [FormField.CountryOfIncorporation]: array()
                .of(string())
                .nullable()
                .min(1, 'Select at least one country')
                .label('Country of Incorporation'),
            [FormField.YearEstablished]: mixed()
                .required()
                .test(
                    'year-not-in-future',
                    function (value: Moment | null) {
                        if (!value) {
                            return true;
                        }

                        if (value.isValid()) {
                            const currentYear = new Date().getFullYear();
                            const year = value.year();

                            if (year > currentYear) {
                                return this.createError({
                                    message: `Year of establishment cannot be in the future. Current year is ${currentYear}.`
                                });
                            }

                            return true;
                        }

                        return this.createError({
                            message: 'Invalid date format for year of establishment.'
                        });
                    })
                .label('Year of Establishment'),
            [FormField.WebsiteUrl]: string()
                .required()
                .trim()
                .url('Enter a valid URL')
                .label('Website URL'),
            [FormField.PrimaryLocation]: string()
                .required()
                .trim()
                .min(1)
                .label('Primary Location'),
            [FormField.CountriesOfBusinessActivity]: array()
                .of(string())
                .min(1, 'Select at least one country')
                .label('Countries of Business Activity'),
            [FormField.Platforms]: array()
                .of(string())
                .optional()
                .label('Platforms'),
        })
    ), []);

export default useValidationSchema;

